import { useQuery } from '@apollo/client'
import { useHistory, useParams } from 'react-router-dom'
import { Box, Flex, Text, Heading } from 'rebass/styled-components'

import Price from '../../components/Price'
import { GET_PRODUCT_BY_HANDLE } from '../../graphql/queries'
import { useCartTotal } from '../../graphql/client'
import {
    IonPage,
    IonLoading,
    IonFooter,
    IonToolbar,
    IonButton,
    IonTabButton,
    IonIcon,
    IonLabel,
    IonBadge,
} from '@ionic/react'
import Header from '../../components/Header'
import HandleAdd from '../../components/HandleAdd'
import IonContent from '../../components/IonContent'
import Carousel from '../../components/Carousel'
import { cart } from 'ionicons/icons'

export default () => {
    const { handle } = useParams()

    const { data, loading } = useQuery(GET_PRODUCT_BY_HANDLE, {
        variables: {
            handle,
        },
    })
    const history = useHistory()
    const detail = data?.productByHandle
    const images = detail?.images?.edges?.map(({ node }) => node)
    const total = useCartTotal()

    return (
        <IonPage>
            <Header title="detail"></Header>
            <IonContent>
                <Carousel data={images}></Carousel>
                <Box px="20px">
                    <Box
                        py="10px"
                        css={{
                            borderBottom: '1px solid #eee',
                        }}
                    >
                        <Heading fontSize="18px">{detail?.title}</Heading>
                        <Flex>
                            <Price mt="5px">{detail?.variants?.edges[0]?.node.price}</Price>
                        </Flex>
                    </Box>
                    <Box
                        css={{
                            maxWidth: '100%',
                            overflowX: 'hidden',
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: detail?.descriptionHtml }}></div>
                    </Box>
                </Box>
                {/* <Flex
                    css={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        bottom: 0,
                        color: '#fff',
                    }}
                >
                    <Flex
                        py="10px"
                        bg="secondary"
                        flex="1"
                        justifyContent="center"
                        onClick={() => history.push('/cart')}
                    >
                        查看购物车
                    </Flex>
                    <HandleAdd variantId={detail?.variants?.edges[0]?.node.id}>
                        <Flex py="10px" bg="primary" flex="1" justifyContent="center">
                            加入购物车
                        </Flex>
                    </HandleAdd>
                </Flex> */}
                <IonLoading isOpen={loading}></IonLoading>
            </IonContent>
            <IonFooter>
                <IonToolbar>
                    <Flex>
                        <Box width="50px">
                            <IonTabButton>
                                <IonIcon icon={cart} />
                                <IonLabel>Cart</IonLabel>
                                {total > 0 && <IonBadge>{total}</IonBadge>}
                            </IonTabButton>
                        </Box>
                        <Flex
                            flex="1"
                            ml="15px"
                            sx={{
                                'ion-button': {
                                    width: '100%',
                                },
                            }}
                        >
                            <HandleAdd variantId={detail?.variants?.edges[0]?.node.id}>
                                <IonButton expand="block">Add to Cart</IonButton>
                            </HandleAdd>
                        </Flex>
                    </Flex>
                </IonToolbar>
            </IonFooter>
        </IonPage>
    )
}
